<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div ref="boxRef" class="wrong-word-box" :class="{ visible: isVisible }">
    <div class="wrong-word-intro">以下为答错或选择不认识的单词:</div>

    <div class="wrong-word-list">
      <div
        v-for="(item, index) in errorWords"
        :key="item.word + '-' + index"
        class="wrong-word-item"
        :style="{ animationDelay: index * 80 + 'ms' }"
      >
        <span class="word-en">单词:{{ item.word }}</span>
        <span class="word-cn">释义:{{ item.pos }}{{ item.meaning }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount ,defineProps} from "vue";

defineProps({
  errorWords: {
    type: Array,
    default: () => [
      { word: "ambiguous", pos: "adj. ", meaning: "模糊的；不明确的" },
      { word: "paradigm", pos: "n. ", meaning: "范例；典范" },
      { word: "coherent", pos: "adj. ", meaning: "连贯的；一致的" },
      { word: "empirical", pos: "adj. ", meaning: "以实验为基础的" },
      { word: "advocate", pos: "v. ", meaning: "提倡；主张" },
    ],
  },
});

const boxRef = ref(null);
const isVisible = ref(false);
let observer = null;

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) isVisible.value = true;
    },
    { threshold: 0.2 }
  );
  if (boxRef.value) observer.observe(boxRef.value);
});

onBeforeUnmount(() => {
  if (observer && boxRef.value) observer.unobserve(boxRef.value);
});
</script>

<style scoped lang="scss">
.wrong-word-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .wrong-word-intro {
    font-size: 15px;
    color: #333333;
    font-weight: 500;
    width: 100%;
  }

  .wrong-word-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 15px;
  }

  .wrong-word-item {
    display: flex;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px dashed #ece8ff;
    opacity: 0;
    transform: translateY(12px);
  }

  &.visible .wrong-word-item {
    animation: wrongWordFadeIn 0.4s ease-out forwards;
  }

  @keyframes wrongWordFadeIn {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .word-en {
    font-size: 16px;
    color: #333333;
    width: 50%;
    text-align: left;
  }

  .word-cn {
    font-size: 16px;
    color: #333333;
    width: 50%;
    text-align: left;
    word-wrap: break-word;
  }
}
</style>
